<template>
  <header
    class="bg-white-50 sticky z-[1024] w-full backdrop-blur-[6px] left-0 top-0 border-b border-black/[0.06]"
  >
    <div class="container mx-auto px-8">
      <div class="grid w-full items-center grid-cols-[auto_1fr_auto]">
        <div class="flex items-center justify-start gap-4">
          <img
            v-if="showBackButton"
            @click="goBack"
            class="left_button_icon"
            src="@/assets/images/Left-button-icon.svg"
            alt="Left Button Icon"
          />
          <router-link v-if="showLeftLogo" :to="{ name: 'Home' }" class="block">
            <img class="logo" src="@/assets/images/logo.png" alt="Logo" />
          </router-link>
        </div>
        <div class="flex items-center justify-center">
          <router-link
            v-if="showCenterLogo"
            :to="{ name: 'Home' }"
            class="block"
          >
            <img class="logo" src="@/assets/images/logo.png" alt="Logo" />
          </router-link>
        </div>
        <div class="flex items-center justify-end gap-4">
          <router-link
            v-if="showAuthSwitcher"
            :to="{ name: authSwitchLink.name }"
            class="auth-switch-link"
          >
            {{ authSwitchLink.label }}
          </router-link>
          <ul
            v-if="showAccountMenu"
            class="menu hidden items-center space-x-4 md:flex"
          >
            <li v-for="link in menuLinks" :key="link.caption">
              <router-link :to="link.to" class="auth-switch-link">{{ link.caption }}</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Groups' }" class="auth-switch-link">
                {{ $t("Live Groups") }}
              </router-link>
            </li>
            <li>
              <AccountMenu />
            </li>
          </ul>
          <button
            v-if="showHamburger"
            @click="toggleHamburger"
            :class="hamburgerButtonClasses"
          >
            <img src="@/assets/images/Hamburger_MD.svg" alt="Menú" />
          </button>
        </div>
      </div>
    </div>
  </header>

  <HeaderHamburger :isOpen="isHamburgerClicked" @close="toggleHamburger" />
</template>

<script>
import { defineComponent } from "vue";
import HeaderHamburger from "@/components/header/headerHamburger.vue";
import AccountMenu from "@/components/account/accountMenu.vue";

export default defineComponent({
  name: "MarketHeader",
  components: {
    HeaderHamburger,
    AccountMenu,
  },
  props: {
    selectedHeader: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isHamburgerClicked: false,
    };
  },
  computed: {
    isDefaultHeader() {
      return this.selectedHeader === "defaultHeader";
    },
    isLoginRegisterHeader() {
      return this.selectedHeader === "loginRegisterHeader";
    },
    isSearchHeader() {
      return this.selectedHeader === "searchHeader";
    },
    isCheckoutHeader() {
      return this.selectedHeader === "checkoutHeader";
    },
    showBackButton() {
      return this.isCheckoutHeader;
    },
    showLeftLogo() {
      return this.isDefaultHeader || this.isSearchHeader || this.isLoginRegisterHeader;
    },
    showCenterLogo() {
      return this.isCheckoutHeader;
    },
    showAccountMenu() {
      return this.isDefaultHeader || this.isSearchHeader || this.isLoginRegisterHeader;
    },
    showAuthSwitcher() {
      return false;
    },
    showHamburger() {
      return this.isDefaultHeader || this.isSearchHeader || this.isLoginRegisterHeader;
    },
    menuLinks() {
      if (this.isSearchHeader) {
        return [{ caption: this.$t("Doctors"), to: { name: "Search" } }];
      }
      return [];
    },
    hamburgerButtonClasses() {
      return ["hamburger", "md:hidden", { "p-2": this.isSearchHeader }];
    },
    authSwitchLink() {
      if (!this.isLoginRegisterHeader) {
        return null;
      }
      const isLoginRoute = this.$route?.name === "Login";
      return {
        name: isLoginRoute ? "Register" : "Login",
        label: this.$t(isLoginRoute ? "register" : "login"),
      };
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    toggleHamburger() {
      this.isHamburgerClicked = !this.isHamburgerClicked;
    },
  },
});
</script>

<style scoped>
.left_button_icon {
  display: inline-block;
  border-radius: 0.6rem;
  transition: 300ms;
  cursor: pointer;
}

.left_button_icon:hover {
  background: #000;
}
.logo {
  max-width: 230px;
  padding: 20px;
}

.search_button {
  width: 4.8rem;
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  border-radius: 10rem;
  border: 1px solid #fff;
  background: #323232;
  backdrop-filter: blur(12px);
}

.filter_info {
  width: 36.2rem;
  height: 4.8rem;
  border-radius: 10rem;
  border: 1px solid #fff;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 4px 16px 0px rgba(190, 190, 190, 0.25);
  backdrop-filter: blur(12px);
}

.auth-switch-link {
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  color: #111827;
  transition: color 0.15s ease;
}

.auth-switch-link:hover {
  color: #5B6FEE;
}

</style>
